import { withTranslation, WithTranslation } from 'react-i18next';
import { Component } from 'react';
import React from 'react';
import NMFunctionalAreaEditor from 'widgets/bussiness/functional-area-editor';
import NMFunctionalSubAreaEditor from 'widgets/bussiness/functional-subarea-editor';
import NMClusterEditor from 'widgets/bussiness/cluster-editor';
import NMTrainingNameEditor from 'widgets/bussiness/training-name-editor';
import { ItemReference } from 'stores/dataStore';
import { Categories } from 'stores/requests/requests-store';
import { Form } from 'semantic-ui-react';

export interface TailwindNonMachineRelatedComponentViewModel {
  cluster: ItemReference;
  functionalArea: ItemReference;
  trainingName: ItemReference;
  functionalSubArea: ItemReference;
}

interface TailwindNonMachineRelatedComponentProps extends WithTranslation {
  readOnly?: boolean;
  value: TailwindNonMachineRelatedComponentViewModel;
  onChange?: (value: TailwindNonMachineRelatedComponentViewModel) => void;
  className?: string;
  category: Categories;
}

class TailwindNonMachineRelatedComponent extends Component<TailwindNonMachineRelatedComponentProps> {
  private handleOnClusterChange = (newCluster: ItemReference) => {
    let newValue = { ...this.props.value };
    newValue.cluster = newCluster;
    newValue.trainingName = null;
    newValue.functionalArea = null;
    newValue.functionalSubArea = null;
    this.props.onChange && this.props.onChange(newValue);
  };

  private handleOnFunctionalAreaChange = (functionalArea: ItemReference) => {
    let newValue = { ...this.props.value };
    newValue.functionalArea = functionalArea;
    newValue.trainingName = null;
    newValue.functionalSubArea = null;
    this.props.onChange && this.props.onChange(newValue);
  };

  private handleOnTrainingNameChange = (trainingLName: ItemReference) => {
    let newValue = { ...this.props.value };
    newValue.trainingName = trainingLName;
    newValue.functionalSubArea = null;
    this.props.onChange && this.props.onChange(newValue);
  };

  private handleOnFunctionalSubAreaChange = (functionalSubarea: ItemReference) => {
    let newValue = { ...this.props.value };
    newValue.functionalSubArea = functionalSubarea;
    this.props.onChange && this.props.onChange(newValue);
  };

  public render() {
    const { t, readOnly, value, category } = this.props;
    const { cluster, functionalArea, functionalSubArea, trainingName } = value;

    return (
      <>
        <div
          key={`${cluster?.id}_${functionalArea?.id}_${functionalSubArea?.id}_${trainingName?.id}`}
          className="bg-gray-50 rounded shadow p-4 mb-4 flex flex-col gap-4"
        >
          <Form>
            <div className="required field">
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('Cluster')}</label>
              <NMClusterEditor
                nullable
                clearable
                category={category}
                readonly={readOnly}
                value={cluster}
                onChange={this.handleOnClusterChange}
                loadDataOnOpen
              />
            </div>

            <div className="required field">
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('Functional Area')}</label>
              <NMFunctionalAreaEditor
                nullable
                clearable
                clearOnReload
                readonly={readOnly || !cluster}
                clusterId={cluster?.id || null}
                value={functionalArea}
                onChange={this.handleOnFunctionalAreaChange}
                loadDataOnOpen
              />
            </div>

            <div className="field">
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('Training Name')}</label>
              <NMTrainingNameEditor
                nullable
                clearable
                clearOnReload
                readOnly={readOnly || !functionalArea}
                funcionalAreaId={functionalArea?.id || null}
                value={trainingName}
                onChange={this.handleOnTrainingNameChange}
                loadDataOnOpen
              />
            </div>

            <div className="field">
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('Functional Subarea')}</label>
              <NMFunctionalSubAreaEditor
                nullable
                clearable
                clearOnReload
                readonly={readOnly || !trainingName}
                trainingNameId={trainingName?.id || null}
                value={functionalSubArea}
                onChange={this.handleOnFunctionalSubAreaChange}
                loadDataOnOpen
              />
            </div>
          </Form>
        </div>
      </>
    );
  }
}

export default withTranslation()(TailwindNonMachineRelatedComponent);
